import Marionette from "backbone.marionette";
import $ from "jquery";

import { heapTrack } from "lib/analytics";
import { formatPhone } from "lib/util";

import UserHandleComponent from "./auth-handle";
import util from "../../util";
import forgotPasswordTemplate from "../../templates/components/auth/auth-forgot-password.jst";

const ForgotPasswordComponent = Marionette.View.extend({
    template: forgotPasswordTemplate,

    ui: {
        backBtn: ".btn-back",
        handleContainer: ".handle-component",
        loginContainer: ".login-container",
        passwordContainer: ".password-container",
    },

    events: {
        "click .auth-choice": "onSendLink",
    },

    serializeData() {
        const mobile = this.model.get("mobile");
        const phone = this.model.get("phone");
        const email = this.model.get("email");

        return {
            confirm: !!this.showConfirmation,
            handle: this.model.getFormattedHandle(),
            email,
            phone: phone ? formatPhone(phone) : null,
            isMobile: mobile,
        };
    },

    onSendLink(event) {
        event.preventDefault();

        const $target = $(event.currentTarget);
        if ($target.hasClass("disabled")) {
            return;
        }

        const mobile = Number($target.data("mobile"));
        this.model.set("mobile", !!mobile);
        this.model.setResetAuthType();

        this.model.save(null, {
            success: () => {
                heapTrack("Auth - Forgot Password Success", { mobile });

                this.showConfirmation = true;
                this.render();
            },
            error: () => {
                util.showToast("Sorry! An error occurred. Please try again later.");
            },
        });
    },

    onRender() {
        if (this.ui.handleContainer.length) {
            this.handleView = new UserHandleComponent({
                ...this.options,
                el: this.ui.handleContainer,
                model: this.model,
                forgot: true,
            });
            this.handleView.render();
            this.listenTo(this.handleView, "success", this.render);
        }
    },
});

export default ForgotPasswordComponent;
